<div id="overlay"></div>
<!-- <form id="overlay11" [formGroup]="frmGroup"> -->
<!-- temp -->

<!-- don't forget to comment this button -->
<!-- <button type="button" class="tiny-value" (click)="fillData()">tiny</button> -->
<!-- don't forget to comment this button -->
<div *ngIf="configData.screenVersion === 'v2'; else oldScreen">

    <div style="height: 100%;">
      <div class="dhl-header-container-v2"
      [ngClass]="configData.titleNoBorder== true ? 'noBorderBottom':''">
      <span *ngIf="selfServiceConfig" (click)="editFieldConfig('false','bannerMsg','')">
      <app-banner-message  *ngIf="configData?.bannerDetails && configData?.bannerDetails?.banner" [message]="$safeNavigationMigration(configData?.bannerDetails?.bannerMessage)" [divIdObj]="{id : 'mainContainerId'}" [termsAndConditions]="$safeNavigationMigration(configData?.bannerDetails?.termsAndConditions)"
       [effectedComp]="$safeNavigationMigration(configData?.bannerDetails?.effectedComp)"
      [termsAndConditionsUrl]="$safeNavigationMigration(configData?.bannerDetails?.termsAndConditionsUrl)"></app-banner-message>
    </span>
    <span *ngIf="!selfServiceConfig">
      <app-banner-message  *ngIf="configData?.bannerDetails && configData?.bannerDetails?.banner" [message]="configData?.bannerDetails?.bannerMessage" [divIdObj]="{id : 'mainContainerId'}" [termsAndConditions]="configData?.bannerDetails?.termsAndConditions"
       [effectedComp]="configData?.bannerDetails?.effectedComp"
      [termsAndConditionsUrl]="configData?.bannerDetails?.termsAndConditionsUrl"></app-banner-message>
    </span>
        <div class="dhl-header-v2 row">
          <div class="title-container" [class]="getColsClass($safeNavigationMigration(configData?.header?.title?.cols))" [class.title-vertical-align]="configData?.header?.title?.subtitle && configData?.header?.title?.redirectTitle">
            <span [ngStyle]="{ 'white-space': configData?.header?.title?.redirectTitleOneLine ? 'nowrap' : 'initial' }" *ngIf="configData?.header?.title?.redirectTitle" (click)="backFn()" type="button">
              <span>
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1700,24,24))"
                class="iconsArrow backBtnTitleStyle">
              </span>
             <span class="paddingLeft_8 titleFontStyle">{{configData?.header?.title?.redirectTitle | translate}}</span>
            </span>

            <div class="title-content">
              <span class="main-subtitle-content" *ngIf="configData?.header?.title?.mainSubtitle">{{configData?.header?.title?.mainSubtitle}}</span>
              <span *ngIf="!selfServiceConfig" >{{configData?.header?.title?.maintitle | translate}}</span>
              <span *ngIf="selfServiceConfig" (click)="editFieldConfig('false','maintitle','')">{{$safeNavigationMigration(configData?.header?.title?.maintitle) | translate}}</span>
              <span class="subtitle-content">{{configData?.header?.title?.subtitle}}</span>
            </div>
            <span *ngIf ="configData && configData.groups && configData.groups.length > 0 && configData.groups[0]?.isSelectAllCount" class="vehicles"><span id="poSelectCount">{{isSelectAllCount}}</span> {{configData?.groups[0]?.isSelectAllCount}}</span>
          </div>
          <div class="action-sm" id="smallDeviceActions" [ngClass]="getColsClass(configData?.header?.action?.cols)">
            <div class="row button-container">
              <div class="col-lg-9 col-md-10 col-sm-12 col-xs-12" [ngClass]="configData.header?.action?.nav || configData.header?.action?.ellipse ? 'col-lg-9 col-sm-9 col-xs-12' : 'col-lg-12 col-sm-12 col-xs-12'">
                <div class="row btn-space">
                  <div *ngFor="let data of configData?.header?.action?.details" [ngClass]="getColsClass(data.cols)"
                  class="col">
                   <button *ngIf="data.view.buttonType === 'download' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="bolDownloadFile()" class="dhl-button-v2 buttons-secondary">
                    {{data.view.label | translate }}
                  </button>
                  <button  *ngIf="data.view.buttonType === 'secondary' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="formReset(data.name)" 
                    class="dhl-button-v2 buttons-secondary"
                    [disabled]="(data.disabled !== false ) && (isLoading || (frmGroup.pristine && frmGroup.untouched))"
                    [style.display] ="getDisplayStyle(data)"
                    [ngClass]="{'disabled-secondary-btn ': enableFinalStepAction && data?.enableFinalStepAction}">{{data.view.label |
                    translate}}</button>
                  <button  *ngIf="data.view.type === 'save' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="saveForm($event, data.command,data.name)"
                    class="dhl-button-v2 buttons-secondary">{{data.view.label | translate}}</button>
                  <button  *ngIf="data.view.buttonType === 'primary' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="submitOrderForm($event, data, data.view.label)"
                    class="dhl-button-v2 buttons-primary"
                    [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false) || data.enableAction === false"
                    [style.display]="getDisplayStyle(data)"
                    [ngClass]="{'disabled-primary-btn ': enableFinalStepAction && data?.enableFinalStepAction}">{{data.view.label
                    | translate}}</button>
                  <!-- //#3738 : Start new button for draft order  -->
                  <button *ngIf="data.view.buttonType === 'draft'" type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="submitOrderForm($event, data, data.view.label)"
                    class="dhl-button-v2 buttons-secondary"
                    [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false) || data.enableAction === false">{{data.view.label | translate}}</button>
                  <!-- //End -->
               
                </div>
              </div>
               <!-- ellipse button for small devices - Mobile -->
              <div *ngFor="let ellipse of configData?.header?.action?.ellipse" [ngClass]="getColsClass(ellipse.cols)"
                [hidden]="ellipse.hidden" class="ellips-container">
                <button class="btn dhl-button-v2 ellip-actions sm-actions" [title]="ellipse.toolTip" [disabled]="ellipse.disabled"
                  (click)="toggleActionDrop(); checkEllipsisAccess(ellipse.actions)">
                  <span><img src="./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1470,24,24))"></span>
                </button>
                <div class="arrow-up sm-arrow" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                  (mouseleave)="toggleActionDrop()"></div>
                <div class="ellipse-drop sm-drop" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                  (mouseleave)="toggleActionDrop()">
                  <ul>
                    <li *ngFor="let action of ellipse.actions" [hidden]="action.hidden" [title]="action.toolTip"
                      (click)="ellipseAction(action)"><img
                        src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,510,24,24))" alt="logo"
                        style="max-height: 25px;max-width: 150px;" *ngIf="action.showIcon" />
                      {{action.text}}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-2 col-sm-3 d-none d-sm-block" *ngIf="configData.header?.action?.nav || configData.header?.action?.ellipse">
              <div class="row ft-r">
                <!-- <div class="col-lg-3 col-sm-3 col-xs-3"></div> -->
                <!-- <div *ngFor="let nav of configData.header.action.nav" [ngClass]="getColsClass(nav.cols)">
                    <button class="btn dhl-button-v2 nav-actions" [title]="nav.toolTip" [disabled]="nav.disabled"
                      (click)="redirectTo(nav?.command?.redirectUrl)">
                      <img src = "./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1380,24,24))" *ngIf="nav.view.icon === 'prevIcon'">
                      <img src = "./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1410,24,24))" *ngIf="nav.view.icon === 'fwdIcon'">
                    </button>
                </div> -->
                <div *ngFor="let ellipse of configData?.header?.action?.ellipse" [ngClass]="getColsClass(ellipse.cols)"
                  [hidden]="ellipse.hidden">
                  <button class="btn dhl-button-v2 ellip-actions" [title]="ellipse.toolTip"
                    [disabled]="ellipse.disabled" (click)="toggleActionDrop(); checkEllipsisAccess(ellipse.actions)">
                    <span><img
                        src="./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1470,24,24))"></span>
                  </button>
                  <div class="arrow-up" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                    (mouseleave)="toggleActionDrop()"></div>
                  <div class="ellipse-drop" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                    (mouseleave)="toggleActionDrop()" [attr.title]="enableFinalStepAction && ellipse?.disabledTooltip ? ellipse.disabledTooltip : null">
                    <ul>
                      <li *ngFor="let action of ellipse.actions" [hidden]="action.hidden" [title]="action.toolTip"
                        (click)="ellipseAction(action)" [ngClass]="{'final-step-disabled': (enableFinalStepAction && !action?.noUserAccessRestriction)}"><img
                          src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,510,24,24))"
                          alt="logo" style="max-height: 25px;max-width: 150px;" *ngIf="action.showIcon" />
                        {{action.text}}</li>
                    </ul>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="stepper 1" [ngClass]="getDefaultCols()"> -->
          
        <div class="stepper" *ngIf="stepperSameRow; else stepperSpace"
          [ngClass]="getColsClass($safeNavigationMigration(configData?.header?.stepper?.cols))">
          <app-horizontal-stepper-v2 [navIn]="navToIndexEmitter" [configData]="$safeNavigationMigration(configData?.header?.stepper)">
          </app-horizontal-stepper-v2>
        </div>
      
          <div *ngIf="configData?.header?.headerInfo" [ngClass]="getColsClass($safeNavigationMigration(configData?.header?.headerInfo?.cols))">
            <app-header-info [configData]="$safeNavigationMigration(configData?.header?.headerInfo)" [headerInfo]="headerDetails"></app-header-info>
          </div>
        
       
        <ng-template #stepperSpace>
          <div *ngIf="headerDetails === undefined && $safeNavigationMigration(configData?.header?.single_order_create_screen) === undefined" [ngClass]="getColsClass($safeNavigationMigration(configData?.header?.stepper?.spaceCols))"></div>
        </ng-template>
        <!-- </div> -->
       
        <div class="action-lg" id="largeDeviceActions" [ngStyle]="{ height: 'fit-content', 'padding-bottom': '6px' }" [ngClass]="getColsClass($safeNavigationMigration(configData?.header?.action?.cols))">
          <div class="row button-container">
              <div class=""
              [ngClass]="getColsClassByConfigData($safeNavigationMigration(configData?.header))">
              <div class="row">
                <div *ngFor="let pageAction of configData?.header?.action?.controls" style="display: inline-block;" class="in-row"> 
                  <app-form-field [configData] = "pageAction" [frmGroup]="formFieldFrmGroup"></app-form-field>
              </div>
                  <div *ngFor="let data of configData?.header?.action?.details; let dataIDX =index;" [ngClass]="getColsClass(data.cols)" [class.d-none]="data?.buttonVisibilityByTask && !data?.visibility"
                  class="col">
                  <button style="width: 100%;" *ngIf="data.view.buttonType === 'download' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="bolDownloadFile()" class="dhl-button-v2 buttons-secondary">
                    {{data.view.label | translate }}
                  </button>
                  <button style="width: 100%;" *ngIf="data.view.type === 'save' " type="{{data.view.type}}" title="{{data.toolTip | translate}}"
                    (click)="saveForm($event, data.command,data.name)" class="dhl-button-v2 buttons-secondary">{{data.view.label | translate}}</button>
                  <button [ngStyle]="{'width': data?.width ? data.width : '100%', 'float':data?.float ? data.float :'left' , 
                  'visibility': (data.visibility === false || !checkHeaderAccess(data,dataIDX)) ? 'hidden' :'visible'}"  
                  *ngIf="data.view.buttonType === 'secondary' " type="{{data.view.type}}"
                  title="{{data.toolTip | translate }}" (click)="formReset(data.name)" class="dhl-button-v2 buttons-secondary" 
                  [disabled]="((['discard', 'cancel', 'save'].includes(data?.name) &&
                  (orderDetails?.status === 'Planned' || orderDetails?.status === 'Confirmed')) ||
                  (data.disabled !== false && (isLoading || (frmGroup.pristine && frmGroup.untouched))) ||
                  (orderStatusValidation && ['discard', 'cancel', 'save', 'reset'].indexOf(data?.name) > -1)) &&
                  data.btnStatusEnabled !== true" [style.display]="getDisplayStyle(data)"
                  [ngClass]="{'disabled-secondary-btn': enableFinalStepAction && data?.enableFinalStepAction}">
                   {{data.view.label | translate}}</button>
                  <button style="width: 100%;" *ngIf="data.view.buttonType === 'resetAndApiCall'" type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="submitOrderForm($event, data, data.view.label)"
                    class="dhl-button-v2 buttons-secondary"
                    [disabled]="((orderDetails?.status === 'Planned') || (orderDetails?.status === 'Confirmed') || (orderDetails?.status === 'SHIP_CONFIRMED' ) && ['discard', 'cancel', 'save','reset'].includes(data?.name)) || isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false || data?.disabled || data.enableAction === false) || (orderStatusValidation && ['discard', 'cancel', 'save'].indexOf(data?.name) > -1)">{{data.view.label
                    | translate}}</button>
                  <button [ngStyle]="{'width': data?.width ? data.width : '100%', 'float':data?.flaot ? data.float :'left' }" *ngIf="data.view.buttonType === 'primary' " type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="submitOrderForm($event, data, data.view.label)"
                    class="dhl-button-v2 buttons-primary" [ngClass]="{'disabled-primary-btn': enableFinalStepAction && data?.enableFinalStepAction, 'btn-multiline-text': (data.view.label | translate)?.length > 15}" [style.display]="checkButtonAccess(data) ? 'inline-block' : 'none !important'"
                    [disabled]="((orderDetails?.status === 'Planned') || (orderDetails?.status === 'Confirmed') || (orderDetails?.status === 'SHIP_CONFIRMED') && ['discard', 'cancel', 'save','reset'].includes(data?.name)) && data?.name !== 'Create Order' && isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false || data?.disabled || data.enableAction === false) || (orderStatusValidation && ['discard', 'cancel', 'save'].indexOf($safeNavigationMigration(data?.name)) > -1)"
                    >{{data.view.label
                    | translate}}</button>
                  <!-- //#3738 : Start new button for draft order  -->
                  <button style="width: 100%;" *ngIf="data.view.buttonType === 'draft'" type="{{data.view.type}}"
                    title="{{data.toolTip | translate}}" (click)="submitOrderForm($event, data, data.view.label)"
                    class="dhl-button-v2 buttons-secondary"
                    [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false) || data.enableAction === false">{{data.view.label | translate}}</button>
                  <!-- //End -->
                </div>
              </div>
            </div>
              <div [ngClass]="getColsClassForConditionBase(configData.header)"
              *ngIf="configData.header?.action?.nav || configData.header?.action?.ellipse">
              <div class="row">
                <!-- <div class="col-lg-3 col-sm-3 col-xs-3"></div> -->
                <div *ngFor="let nav of configData.header.action.nav" [ngClass]="getColsClass(nav.cols)" [hidden]="nav.hidden">
                    <button class="btn dhl-button-v2 nav-actions" [title]="nav.toolTip" [disabled]="nav.disabled"
                      (click)="redirectTo(nav.name)">
                      <img src = "./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1380,24,24))" *ngIf="nav.view.icon === 'prevIcon'">
                      <img src = "./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1410,24,24))" *ngIf="nav.view.icon === 'fwdIcon'">
                    </button>
                </div>
                <div *ngFor="let ellipse of configData?.header?.action?.ellipse" [ngClass]="getColsClass(ellipse.cols)"
                  [hidden]="ellipse.hidden">
                  <button class="btn dhl-button-v2 ellip-actions" [title]="ellipse.toolTip"
                    [disabled]="ellipse.disabled" (click)="toggleActionDrop(); checkEllipsisAccess(ellipse.actions)">
                    <span><img
                        src="./../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1470,24,24))"></span>
                  </button>
                  <div class="arrow-up" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                    (mouseleave)="toggleActionDrop()"></div>
                  <div class="ellipse-drop" *ngIf="!ellipse.disabled && !ellipse.hidden && ellipseBtn.showDrop"
                    (mouseleave)="toggleActionDrop()" [attr.title]="enableFinalStepAction && ellipse?.disabledTooltip ? ellipse.disabledTooltip : null">
                    <ul>
                      <li *ngFor="let action of ellipse.actions" [hidden]="action.hidden" [title]="action.toolTip"
                        (click)="ellipseAction(action)" [ngClass]="{'final-step-disabled': (enableFinalStepAction && !action?.noUserAccessRestriction)}"><img
                          src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,510,24,24))"
                          alt="logo" style="max-height: 25px;max-width: 150px;" *ngIf="action.showIcon" />
                        {{action.text}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stepper 2" *ngIf="headerDetails === undefined && $safeNavigationMigration(configData?.header?.single_order_create_screen) === undefined" style="margin: auto" [ngClass]="getColsClass($safeNavigationMigration(configData?.header?.stepper?.cols))">
          <app-horizontal-stepper-v2 *ngIf="!stepperSameRow" [navIn]="navToIndexEmitter"
            [configData]="configData.header.stepper"></app-horizontal-stepper-v2>
        </div>
      </div>
      <!----Error message Start-->
      <div *ngIf="configData?.errorCount">
        <div class="error-bg-style" *ngIf="totalError > 0">
          <span>
            <img src="../../../../assets/images/icons-error.svg" class="iconserror">
          </span>
          <span class="notification-text">
            * {{totalError}} {{constant?.ERROR_MSG_COUNT}}
          </span>
        </div>
      </div>
      <!--End-->
      <!---Only for draft order Error message-->
      <div *ngIf="isDarftGetError">
        <div class="error-bg-style">
          <span>
            <img src="../../../../assets/images/icons-error.svg" class="iconserror">
          </span>
          <span class="notification-text">
            * {{totalError > 0 ? totalError : ''}}
            {{totalError > 0 ?  constant?.ERROR_MSG_COUNT : constant?.ERROR_MSG_DRAFT}}
          </span>
        </div>
      </div>
      <!-----End-->

      <!-- Order Status Sub-header Start -->
      <div [ngClass]="{ 'd-none-important': !isSubHeaderVisible}"
        class="order-status-header d-flex align-items-center px-4 py-2">
      
        <div class="d-flex align-items-center gap-3">
          <!-- Dynamic Status Badge -->
          <div *ngIf="badgeText" class="status-badge d-flex align-items-center justify-content-center {{badgeClassName}}">
            {{ badgeText }}
          </div>
      
          <!-- Dynamic Info Fields -->
          <div class="tracking-text">
            <span *ngIf="badgeStatus" class="info-block" style="margin-left: 4px;">
              <strong>{{ badgeStatus }}</strong>
            </span>
      
            <ng-container *ngFor="let field of infoFieldsToDisplay">
              <span *ngIf="subHearderInfo?.[field?.key] && isVisible(field, badgeStatus)"
                class="info-block">
                {{ field.label }}: {{ subHearderInfo[field.key] }}
              </span>
            </ng-container>
          </div>
        </div>
      
        <!-- Dynamic Tracking Link -->
        <a *ngIf="trackingLinkField?.redirectURL && isVisible(trackingLinkField, badgeStatus)"
          [href]="$safeNavigationMigration(trackingLinkField?.redirectURL?.replace('/shipmentIdentifier', $safeNavigationMigration(subHearderInfo?.shipmentIdentifier)))"
          [attr.target]="trackingLinkField?.target || '_blank'" class="track-link d-flex align-items-center gap-1">
      
          <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2960,16,16))" alt="Track Icon"
            class="track-icon">
          <span>{{ trackingLinkField.label }}</span>
        </a>
      </div>
      <!-- Order Status Sub-header End -->
    </div>
  </div>
  <div *ngIf="subform && frmGroup['form'];else formGroup">
    <div *ngFor="let subform of frmGroup['form'];let idx = index">
      <app-subform [configData]="configData.sections[idx]" [frmGroup]="subform"></app-subform>
    </div>
  </div>
  <ng-template #formGroup>
    <form id="overlay11" [formGroup]="frmGroup">
      <div id="dhlFormContentV2" class="dhl-content-v2 row dhl-grid-v2 mr-0 ml-0" *ngIf="configData.sections"
      [ngClass]="getBannerDetail()" [class.mt-sub-header]="isSubHeaderVisible">
        <!-- <div [ngClass]="getFormVisibility(stepperIindex)"></div> -->
        <app-form-field  style="width: 100%;" id="{{section.name}}" *ngFor="let section of configData.sections;let stepperIindex=index" [class]="getFormVisibility(stepperIindex)" [configData]="section"
          [frmGroup]="frmGroup" [ngClass]="getColsClass(section.cols)">
        </app-form-field>
      </div>

      <div *ngIf="configData.groups" class="dhl-content-v2 dhl-grid-v2 mr-0 ml-0"
      [ngClass]="getBannerDetail()">
        <div *ngFor="let group of configData.groups;let grpIdx =index;">
          <!-- start- form inside accordion -->
          <div *ngIf="group.component === 'ACCORDION_V2' && group.visibility !== false" attr.id="accordion{{grpIdx}}" [ngClass]="{'dhl-accordion-container': true, 'accordion-expand': group.isActive, 'accordion-collapse': !group.isActive}">
            <div class="dhl-accordion" (click)="toggleAccordian(group,$event)">
              <div fxFlex="88%" class="label" *ngIf="group.label && group.visibility !== false && checkSectionAccess(group,grpIdx)">
                  <span>{{group.label | translate}}</span> 
              </div>
              <div fxFlex="9%" class="group-action">
                <span *ngIf="group.groupLevelAction" class="group-level-action">  
                  <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
                </span>
              </div>
              <div fxFlex="3%" [ngClass]="{'arrow-icon': true, 'open': group.isActive, 'closed': !group.isActive}">
              </div>
            </div>
            <div *ngIf="group.showGroupEnrichmentMessage" class="substatus-msg">
              <div [innerHtml]= "group.groupEnrichmentMessage"> </div>
            </div>
            <div class="dhl-accordion-content-wrapper" id="accordionContent" [hidden]="!group.isActive">
              <div class="dhl-accordion-content">
                <div [class.hide]="frmGroup?.get(control.name)['hidden'] || group.visibility === false || !checkSectionAccess(group,grpIdx)" *ngFor="let control of group.controls" [ngClass]="getColsClass(control.cols, control)">
                  <app-form-field  [configData]="control" [screenVersion]="configData.screenVersion"  [frmGroup]="frmGroup"></app-form-field>
                </div>             
               </div>
            </div>
          </div>
          <!-- End -->
          <div *ngIf="group.component != 'ACCORDION_V2'">
            <div *ngIf="group.visibility !== false && grpIdx !== 0 && checkSectionAccess(group,grpIdx) && group.showDividerLine !== false" [ngClass]="{'section-align': configData?.action !== 'MRN_SUBMIT'}">
              <mat-divider class="section-divider"></mat-divider>
            </div>
            <div *ngIf="group.label && group.visibility !== false && checkSectionAccess(group,grpIdx) && !rateCustom && !selfServiceConfig" class="dhl-group-title-v2">
              {{ group.label | translate}}
              <div *ngIf="group?.tooltip && group.tooltip?.message[frmGroup.get($safeNavigationMigration(group?.tooltip?.controllerName)).value?.value]" class="tt">
                <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))" style="width:20px;height:20px" type="image/svg+xml" />
                <span class="tt-text">{{ $safeNavigationMigration(group.tooltip?.message[frmGroup.get($safeNavigationMigration(group?.tooltip?.controllerName)).value?.value]) | translate }}</span>
              </div>
              <div *ngIf="group.groupLevelAction" class="group-level-action">  
                <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
              </div>
            </div>
            <div *ngIf="group.label && group.visibility !== false && checkSectionAccess(group,grpIdx) && !rateCustom && selfServiceConfig" (click)="editFieldConfig('false',group.label,'')" class="dhl-group-title-v2">
              {{ group.label | translate}}
              <div *ngIf="group?.tooltip && group.tooltip?.message[frmGroup.get(group?.tooltip?.controllerName).value?.value]" class="tt">
                <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))" style="width:20px;height:20px" type="image/svg+xml" />
                <span class="tt-text">{{ group.tooltip?.message[frmGroup.get(group?.tooltip?.controllerName).value?.value] | translate }}</span>
              </div>
              <div *ngIf="group.groupLevelAction" class="group-level-action">  
                <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
              </div>
            </div>
            <div *ngIf="group.label && group.visibility !== false && checkSectionAccess(group,grpIdx) && rateCustom" class="dhl-group-title">
              {{ group.label | translate}}
              <div *ngIf="group.groupLevelAction" class="group-level-action">  
                <app-additional-information-v2 [additionalInfo]="group.groupLevelAction" [configData] = "group"></app-additional-information-v2>                                    
              </div>
            </div>
            <div *ngIf="selfServiceConfig" class="row" cdkDropList (cdkDropListDropped)="drop($event,group.label)">
              <div [class.hide]="frmGroup?.get(control.name)['hidden'] || group.visibility === false || !checkSectionAccess(group,grpIdx)" cdkDrag *ngFor="let control of group.controls; let crlIdx = index" [ngClass]="getColsClass(control.cols, control)" class="padding-right5">
                <div *ngIf="selfServiceConfig" class="col mat-header-cell">
                  <span (click)="removeFields($event,control,grpIdx,crlIdx)">
                    <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1170,24,24))">
                </span>
                  <span (click)="editFieldConfig('false','updateField',control)">
                    <img src='../../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,5025,24,24))'>
                  </span>
              </div> 
                <app-form-field [configData]="control" [screenVersion]="configData.screenVersion"  [frmGroup]="frmGroup"></app-form-field>
              </div>
            </div>
            <div *ngIf="!selfServiceConfig" class="row">
              <div [class.hide]="frmGroup?.get(control.name)['hidden'] || group.visibility === false || !checkSectionAccess(group,grpIdx)" *ngFor="let control of group.controls" [ngClass]="getColsClass(control.cols, control)" class="padding-right5">
                <app-form-field  [configData]="control" [screenVersion]="configData.screenVersion"  [frmGroup]="frmGroup"></app-form-field>
              </div>
            </div>
          </div>
          <span *ngIf="selfServiceConfig"  (click)="editFieldConfig('false','addField',group.label)">
            <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1140,24,24))">
            <span class="add-label">Add New Field</span>
          </span>
        </div>
      </div>
    </form>
  </ng-template>

</div>
<!--
  <div *ngIf="configData.header; else oldScreen">
    <div class="dhl-header-v2 row">
      <div class="title" [ngClass]="getColsClass(configData.header.title.cols)">
        <div>
          <span>{{configData.header.title.maintitle}}</span>
          <span>{{configData.header.title.subtitle}}</span>
        </div>
      </div>
      <div class="stepper" [ngClass]="getColsClass(configData.header.stepper.cols)">
        <app-horizontal-stepper-v2 [configData]="configData.header.stepper"></app-horizontal-stepper-v2>
      </div>
      <div class="action" [ngClass]="getColsClass(configData.header.action.cols)">
        <div class="row">
          <div [ngClass]="getColsClass(data.cols)" *ngFor="let data of configData.header.action.details ">
            <button style="width: 100%;" *ngIf="data.type == 'reset' " type="{{data.view.type}}" (click)="formReset(data.name)"
              class="btn btn-outline buttons-primary dhl-button"
              [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched)">{{data.view.label}}</button>
            <button style="width: 100%;" *ngIf="data.type == 'submit' " type="{{data.view.type}}"
              (click)="submitOrderForm($event, data, data.view.label)" class="btn btn-primary dhl-button buttons-secondary"
              [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false)">{{data.view.label}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="dhl-content-v2" *ngFor="let group of configData.groups;let rowIndex = index">
      <div class="row">
        <app-form-field *ngFor="let control of group.controls" [configData]="control" [frmGroup]="frmGroup"
          [ngClass]="getColsClass(control.cols)">
        </app-form-field>
      </div>
      <div style="padding:10px 0 30px 0;" *ngIf="rowIndex !== configData.groups.length-1">
        <div class="divider" style="border-top: 4px solid #092074;"></div>
      </div>
    </div>
  </div> -->

<ng-template #oldScreen>
  <form id="overlay11" [formGroup]="frmGroup">
    <div *ngIf = "configData.component !== 'FORM_FILTER_V3'; else filterForm">
      <div *ngIf="configData.groups; else notShow" class="accordion-container">
        <div class="accordion-panel"
          *ngFor="let group of configData.groups;let rowIndex = index" [class.expanded]="group.open">
          <div (click)="setAccordionStatus($event, group.open, rowIndex)" class="accordion-header">
            <span class="accordion-title">
              {{ group.name }}
            </span>
            <span class="accordion-toggle" [class.expanded]="group.open" *ngIf="group.collapsable">▼</span>
          </div>
          <div class="accordion-content" [class.show]="group.open">
            <div class="row">
              <app-form-field *ngFor="let control of group.controls" [configData]="control"
                [ngClass]="getColsClass(control.cols)" [frmGroup]="frmGroup"></app-form-field>
            </div>
          </div>
        </div>
      </div>
  
      <ng-template #notShow>
        <div *ngIf="selfServiceConfig" class="row">
          <div *ngIf="selfServiceConfig">
            <span (click)="editFieldConfig('false','updateField',configData)">
              <img src='../../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,5025,24,24))'>
            </span>
        </div> 
          <div *ngFor="let control of configData.controls; let crlIdx = index" [ngClass]="getColsClass(control.cols, control)" class="padding-right5">
            <app-form-field [configData]="control" [screenVersion]="configData.screenVersion"  [frmGroup]="frmGroup"></app-form-field>
          </div>

        </div>
        <div  *ngIf="!selfServiceConfig" class="row">
          <app-form-field *ngFor="let control of configData.controls" [configData]="control" [frmGroup]="frmGroup"
            [ngClass]="getColsClass(control.cols, control)">  
          </app-form-field>
        </div>
      </ng-template>
    </div>

    <!-- For Form-Filter-V3 groups -start  -->
    <ng-template #filterForm>
      <div *ngIf="configData.groups" class="dhl-grid-v2 mr-0 ml-0">
        <div *ngFor="let group of configData.groups;let grpIdx =index;">    
          <div *ngIf="group.label && group.visibility !== false && checkSectionAccess(group,grpIdx)"
            class="dhl-group-title-v2-filter">
            {{ group.label | translate}}
          </div>
          <div class="row">
            <div
              [class.hide]="frmGroup?.get(control.name)['hidden'] || group.visibility === false || !checkSectionAccess(group,grpIdx)"
              *ngFor="let control of group.controls" [ngClass]="getColsClass(control.cols, control)">
              <app-form-field [configData]="control" [screenVersion]="configData.screenVersion"
                [frmGroup]="frmGroup"></app-form-field>
            </div>
          </div>    
        </div>
        <!-- end -->
      </div>
    </ng-template>
  </form>
  <div *ngIf="searchMessage && searchDataLength == 0" class="empty-error-message">{{ searchMessage }}</div>
  <div *ngIf="configData.actions">
    <div *ngIf="turnOnAction" fxFlex fxLayout fxLayoutAlign="flex-end" fxLayoutGap="14px" style="margin-top:16px">
      <!-- if disableIsFormInvalid is true, submit button will disable when form status is invalid(ex: customer onboard domain search)-->
      <div *ngFor="let data of configData.actions ">
        <button *ngIf="data.type === 'reset' " type="{{data.view.type}}" (click)="formReset(data.name)" title={{data.toolTip}}
          class="btn btn-outline dhl-button" [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched)">{{data.view.label}}</button>
        <button *ngIf="data.type === 'submit' " type="{{data.view.type}}" title={{data.toolTip}} (click)="submitOrderForm($event, data, data.view.label)"
          class="btn btn-primary dhl-button" [disabled]="isLoading || (frmGroup.pristine && frmGroup.untouched) || (data.command.disableIsFormInvalid ? frmGroup.invalid : false) || data.enableAction === false">{{data.view.label}}</button>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="editField" class="dhl-form-self-service">
  <div class="sidemenu-header">
      <span class="dhl-icon-compoenent-cancel-v2" (click)="editFieldConfig('cancel','','')"></span>
  </div>    
  <app-form-comp *ngIf="templateData" (formStatus)="getFormStatus($event)"   (form)="getForm($event)" [configData]=templateData [orderDetails]="configData" [lableForConfig]="lableForConfig"></app-form-comp>
  <div class="sidemenu-header">
      <span class="dhl-icon-generic-form-field-v2" (click)="editFieldConfig('cancel','','')"></span>
  </div>
</div>
<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
<!-- </form> -->